import barba from '@barba/core';
import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.pictureScroll()
        });
        barba.hooks.after((data) => {
            this.pictureScroll()
        });

    }
    pictureScroll(){
        this.trigger = document.querySelector('.js-scrollTrigger__picture');
        this.elem = document.querySelectorAll('.js-scrollElem__picture');
        if(this.elem) {
            this.elem.forEach((el, i) => {
                gsap.to(el, {
                    x: '-10vw',
                    scrollTrigger: {
                      trigger: this.trigger,
                      start: 'top bottom' ,
                      end: '+150% center',  
                      scrub: 1, 
                    }
                });
            })
        }
    }
}